/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function t(t,n=0){if(0===n)return t;const r=Math.cos(n),o=Math.sin(n),[c,e]=t;return[c*r+e*-o,c*o+e*r]}export{t as rotate};
